export var AvatarTestIds = {
    /** Test ID to grab the MUI Avatar element */
    AVATAR: 'hawkins-avatar-avatar',
    /** Test ID to grab the image element if it exists */
    IMAGE: 'hawkins-avatar-image',
    /** Test ID to grab the root element */
    ROOT: 'hawkins-avatar-root',
    /** Test ID to grab the end adornment */
    END_ADORNMENT: 'hawkins-avatar-end-adornment',
};
